import { ReactComponent } from "./ic_route_result_circle_blue.svg";

interface Props {
  width?: string;
  height?: string;
  fill?: string;
}

const RouteResultCircleBlueIcon: React.FC<Props> = (props) => (
  <ReactComponent {...props} />
);

export default RouteResultCircleBlueIcon;
